import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  tgsHandleAddHeatingSchedule,
  tgsHandleAts,
  tgsHandleInstantHeat,
  tgsHandleShutOff,
  tgsHandleSnowSensor,
  tgsHandleWindFactor,
  tgsHandleFanOnly,
  selectTgsSwitch,
  tgsHandleOpenMachineController,
  tgsHandleAtsSelection,
  tgsHandleUnSelectIndividualMachine,
  tgsResetMachinesState,
  tgsSpecificLocationUnselectMachinesHandler,
} from '../store/slices/tgsSwitchSlice';

import { useMediaQuery } from 'react-responsive';

import styled from 'styled-components';
import MasterControlBySwitch from '../commonComponentsMC/MasterControlBySwitch';
import IntegratedSwitchLocations from '../commonComponentsMC/IntegratedSwitchLocations';
import {
  handleOpenMasterControl,
  handleTgsInitialState,
  selectMCIsExpanded,
} from '../store/slices/MCIsExpandedSlice';
import { selectUnits } from '../store/slices/settings/unitsSlice';
import { handleResetAllSelectBySwitch } from '../store/slices/masterControlBySwitchSelectSlice';
import { handleResetAllSelectByLocation } from '../store/slices/masterControlSelectByLocationSlice';
import {
  useGetScheduleQueries,
  useSetZoneOpeningsState,
  useZonesQuery,
} from '../../hooks';
import { getCommandNumberService } from '../../services';
import { selectUserPermissions } from '../store/slices/userSlice';
import mainMessageBoxHandler from '../../helpers/ess-tgs-tes-mc/mainMessageBoxHandler';
import testData from '../../test_data/testData';
import EssTgsTesProvider, {
  EssTgsTesContext,
} from '../context/contextOfEssTgsTes';
import { loopMachinesHandler } from '../../helpers/ess-tgs-tes-mc';
import { useSetOpenMasterControl } from '../../hooks/ess_tgs_tes_hooks/useSetOpenMasterControl';

const TgsMain = ({ isMasterControl }) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });

  const { tgsSwitch,flatTgsSwitch } = useSelector(selectTgsSwitch);
  const MCIsExpanded = useSelector(selectMCIsExpanded);
  const { masterControl } = MCIsExpanded.tgs;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;

  const permissions = useSelector(selectUserPermissions);

  const { messageBoxHandler } = useContext(EssTgsTesContext);

  const dispatch = useDispatch();

  useGetScheduleQueries(flatTgsSwitch, 'TGS');

  useSetOpenMasterControl('tes', isMobile);

  useSetZoneOpeningsState(
    flatTgsSwitch,
    masterControl,
    tgsHandleOpenMachineController,
    'tgs'
  );

  const { data: tgsZones } = useZonesQuery('tgs');

  const integratedButtonHandler = (
    id,
    state,
    scope,
    temp,
    data,
    type,
    specificLocation
  ) => {
    loopMachinesHandler(
      id,
      state,
      scope,
      type,
      temp,
      data,
      isF,
      tgsZones,
      'TGS',
      flatTgsSwitch,
      dispatch,
      tgsHandleUnSelectIndividualMachine,
      tgsSpecificLocationUnselectMachinesHandler,
      handleResetAllSelectBySwitch,
      handleResetAllSelectByLocation,
      messageBoxHandler,
      tgsSwitch
    );

  };

  return (
    <Wrapper>
      {isMasterControl ||
        (permissions.MASTER_CONTROL && (
          <Section>
            <MasterControlBySwitch
              swtName='tgs'
              buttonHandler={integratedButtonHandler}
            />
          </Section>
        ))}

      <Section>
        <IntegratedSwitchLocations
          swtName='tgs'
          buttonHandler={integratedButtonHandler}
        />
      </Section>
    </Wrapper>
  );
};

export default TgsMain;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Section = styled.section`
  &:first-child {
    margin-bottom: 8px;
  }
`;

